import { useMemo } from "react";
import {
  daoYearAt,
  remainingInCurrentYear,
  yearBoundaries,
} from "@/lib/stake/dao-year";
import { useLaunchTime } from "./useLaunchTime";

export type DaoYearData = {
  currentYear: number;
  remaining: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
  boundaries: (yearIndex: number) => { start: bigint; end: bigint };
  launchTime: bigint;
};

/**
 * Composes useLaunchTime with DAO year arithmetic.
 * Returns undefined while launch time is loading.
 * `now` is captured once at call time — no polling.
 */
export function useDaoYear(): DaoYearData | undefined {
  const { data: launchTime } = useLaunchTime();

  return useMemo(() => {
    if (launchTime === undefined) return undefined;

    const nowSec = BigInt(Math.floor(Date.now() / 1000));

    return {
      currentYear: daoYearAt(nowSec, launchTime),
      remaining: remainingInCurrentYear(nowSec, launchTime),
      boundaries: (yearIndex: number) => yearBoundaries(yearIndex, launchTime),
      launchTime,
    };
  }, [launchTime]);
}
